import { type UserLocation } from '@kijiji/generated/graphql-types'

import { DEFAULT_USER_LOCATION } from '@/constants/location'
import { convertCookieToUserLocation } from '@/domain/location/convertCookieToUserLocation'
import { getLatestSearchCookieValues } from '@/utils/cookies/latestSearchCookie'

/**
 * Returns the initial location data from latest search cookie
 * If none found, returns the default location
 */
export const getInitialUserLocation = (userPreferenceCookie?: string): UserLocation => {
  const latestSearch = getLatestSearchCookieValues(userPreferenceCookie)

  /**
   * Set location as "allCanada" if no cookie was ever set
   */
  if (!latestSearch) {
    return DEFAULT_USER_LOCATION
  }

  const location = convertCookieToUserLocation(latestSearch)

  return location
}
